export const locales = ['ru', 'en', 'sk'] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

/** BCP 47 tags used for `hreflang` and `<html lang>`. */
export const localeTags: Record<Locale, string> = {
  ru: 'ru',
  en: 'en',
  sk: 'sk-SK',
};

export function isLocale(value: unknown): value is Locale {
  return locales.includes(value as Locale);
}

export function localePath(locale: Locale, path = ''): string {
  return `/${locale}${path}`;
}
